import React, { useState, useEffect } from 'react';
import { adminAPI } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import {
  Users,
  Stethoscope,
  Calendar,
  Wallet,
  Activity,
  AlertCircle,
  Loader2
} from 'lucide-react';

const AdminStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await adminAPI.getStats();
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Loader2 className="w-8 h-8 text-red-500 animate-spin" />
      </div>
    );
  }

  const statCards = [
    {
      title: 'Patients',
      value: stats?.total_patients || 0,
      icon: Users,
      color: 'bg-blue-100 text-blue-600',
    },
    {
      title: 'Professionnels',
      value: stats?.total_professionals || 0,
      icon: Stethoscope,
      color: 'bg-red-100 text-red-500',
    },
    {
      title: 'En attente',
      value: stats?.pending_validations || 0,
      icon: AlertCircle,
      color: 'bg-amber-100 text-amber-600',
    },
    {
      title: 'RDV total',
      value: stats?.total_appointments || 0,
      icon: Calendar,
      color: 'bg-purple-100 text-purple-600',
    },
    {
      title: 'RDV aujourd\'hui',
      value: stats?.appointments_today || 0,
      icon: Activity,
      color: 'bg-emerald-100 text-emerald-600',
    },
    {
      title: 'Revenus (FCFA)',
      value: stats?.total_revenue?.toLocaleString() || 0,
      icon: Wallet,
      color: 'bg-rose-100 text-rose-600',
    },
  ];

  return (
    <div className="section-padding py-6" data-testid="admin-stats-page">
      <div className="mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900" style={{ fontFamily: 'Plus Jakarta Sans' }}>
          Statistiques
        </h1>
        <p className="text-slate-600 mt-1">Vue d'ensemble de la plateforme</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {statCards.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="border-0 shadow-sm">
              <CardContent className="p-6">
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${stat.color}`}>
                    <Icon className="w-7 h-7" />
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-slate-900">{stat.value}</p>
                    <p className="text-sm text-slate-500">{stat.title}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default AdminStats;
